"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.posterScreen = void 0;

var _html2canvas = _interopRequireDefault(require("html2canvas"));

var _common = require("../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @file 分享海报截图
 * @author liumengzhu
 * @date 2022-07-19
 */

/**
 * 利用 App 截取指定 分享海报DOM 区域。
 */

/**
 * h5分享海报截图
 * @param {Object} options
 * @options {HTMLElement=} options.el 截取的 DOM 元素
 * @options {string=} options.imageType 保存的图片类型，默认 image/png，如果需要减小图尺寸，建议使用 image/jpeg
 * @options {Object=} options.canvasOptions html2canvas 的 config 配置项
 * @options {number=} options.encoderOptions 图片质量，0-1 区间，只至针对 jpeg 和 webp 有效。默认 0.92
 * @options {Function=} options.beforeShare 触发分享前的钩子函数，返回 true 时不返回base64的图片地址
 */
var posterScreen = {
  screenshot: function screenshot(options) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var el = options.el,
          _options$imageType = options.imageType,
          imageType = _options$imageType === void 0 ? 'image/png' : _options$imageType,
          canvasOptions = options.canvasOptions,
          encoderOptions = options.encoderOptions,
          _options$beforeShare = options.beforeShare,
          beforeShare = _options$beforeShare === void 0 ? function () {} : _options$beforeShare;
      var base64Img = '';

      if (el) {
        var cavOpts = (0, _common.defaults)(canvasOptions, {
          width: el.offsetWidth,
          height: el.offsetHeight,
          useCORS: true
        });
        (0, _html2canvas["default"])(el, cavOpts).then(function (canvas) {
          var context = canvas.getContext('2d');
          context.mozImageSmoothingEnabled = false;
          context.webkitImageSmoothingEnabled = false;
          context.msImageSmoothingEnabled = false;
          context.imageSmoothingEnabled = false;
          var skip = beforeShare.call(_this, {
            el: el,
            canvas: canvas
          });

          if (skip) {
            reject();
          } else {
            base64Img = canvas.toDataURL(imageType, encoderOptions);
            resolve(base64Img);
          }
        });
      }
    });
  }
};
exports.posterScreen = posterScreen;